import { IHotListAnalyticsConfiguration } from '@epicuro-next/constants/rule-engine/product-list-rules';
import { DateTime, Duration } from 'luxon';

export function getDateRangeFromHottestListConfig(
  config: IHotListAnalyticsConfiguration,
) {
  const { calculateHotInCurrentMonth, lastNDaysToCalculateHot } = config;

  const to = DateTime.utc().endOf('day');

  let from: DateTime;

  if (calculateHotInCurrentMonth) {
    from = DateTime.utc().startOf('month');
  } else if (lastNDaysToCalculateHot) {
    from = DateTime.utc().minus(
      Duration.fromObject({ days: lastNDaysToCalculateHot }),
    );
  } else {
    return undefined;
  }

  from = from.startOf('day');

  return {
    from: from.toISO(),
    to: to.toISO(),
  };
}
